// extracted by mini-css-extract-plugin
module.exports = {"ViolationBadge":"draft_violations_ViolationBadge__2LXxk","ViolationBadge_Acknowledged":"draft_violations_ViolationBadge_Acknowledged__3AMwz"};